import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tabIndex: 1,
    keyword: '',
    search: 0,
    isLogin: false,
    token: '',
  },
  mutations: {
    updateLogin(state, playload) {
      state.isLogin = playload.isLogin;
      state.token = playload.token;
    },
  },
  actions: {},
  modules: {},
});
